module.exports = __webpack_public_path__ + "static/media/phone-app.e717ece3.png";